import React, { createContext, useContext, useState, useEffect } from "react";

const LangContext = createContext(null);

const T = {
    en: {
        // nav
        nav_home: "Home", nav_programs: "Programs", nav_trainings: "Trainings",
        nav_reviews: "Reviews", nav_contact: "Contact", nav_book: "Book Training",
        // hero
        hero_tag: "Online Football Academy · Frankfurt",
        hero_line1: "Train like a pro.", hero_line2: "Play like an elite.",
        hero_body: "Football programs & online coaching. Working with players from pro academies. Personal and group training in Frankfurt.",
        hero_cta_programs: "Explore Programs", hero_cta_book: "Book Frankfurt Training",
        // programs
        programs_title: "Programs",
        programs_sub: "Multi-week plans designed by Elite Player Academy. Choose what you need and start making progress.",
        weeks: "weeks", age: "Age", open_program: "Open Program",
        next_programs: "Next Programs", coming_soon: "Coming Soon…",
        // program detail
        back_to_programs: "Back to Programs", read_more: "Read more", read_less: "Read less",
        program_will_improve: "Program will improve", program_includes: "Program includes",
        week_structure: "5-week structure", check_reviews: "Check out players' reviews about programs",
        buy_program: "Buy Program",
        // trainings
        trainings_title: "Trainings · Frankfurt", trainings_hero: "Train with us",
        trainings_body: "Book a 1-on-1 or small group session in Frankfurt. Analysis, assessment, and a planned strategy for the progress of key aspects. Personalized approach, elite training and support.",
        book_your_session: "Book your session",
        // reviews
        reviews_title: "Our players, their wins & feedback",
        reviews_sub: "Read what our players and their parents think about working with us and our training programs.",
        rev_trainings: "Trainings", rev_programs: "Programs",
        our_players_from: "Our players from",
        // contact
        contact_title: "Contact", explore: "Explore",
        contact_body: "Training the next generation of elite footballers. World-class drills, structured programs, and 1-on-1 & group sessions in Frankfurt am Main.",
        social_connect: "Social · Connect",
        // order
        order_title: "Complete your purchase",
        order_first: "First name", order_last: "Last name", order_email: "Email",
        order_pay: "Pay with card", order_cancel: "Cancel",
        // legal
        impressum: "Impressum", datenschutz: "Datenschutz", cookie: "Cookie",
    },
    de: {
        nav_home: "Startseite", nav_programs: "Programme", nav_trainings: "Training",
        nav_reviews: "Bewertungen", nav_contact: "Kontakt", nav_book: "Training buchen",
        hero_tag: "Online-Fußballakademie · Frankfurt",
        hero_line1: "Trainiere wie ein Profi.", hero_line2: "Spiel wie ein Elite.",
        hero_body: "Fußball-Programme & Online-Coaching. Wir arbeiten mit Spielern aus Profi-Akademien. Plus 1-zu-1- und Gruppentraining in Frankfurt.",
        hero_cta_programs: "Programme entdecken", hero_cta_book: "Frankfurt-Training buchen",
        programs_title: "Programme",
        programs_sub: "Mehrwöchige Pläne der Elite Player Academy. Wähle, was du brauchst, und starte deinen Fortschritt.",
        weeks: "Wochen", age: "Alter", open_program: "Programm öffnen",
        next_programs: "Nächste Programme", coming_soon: "Bald verfügbar…",
        back_to_programs: "Zurück zu den Programmen", read_more: "Mehr lesen", read_less: "Weniger",
        program_will_improve: "Was dieses Programm verbessert", program_includes: "Inhalte des Programms",
        week_structure: "5-Wochen-Struktur", check_reviews: "Bewertungen zu den Programmen ansehen",
        buy_program: "Programm kaufen",
        trainings_title: "Training · Frankfurt", trainings_hero: "Trainiere mit uns",
        trainings_body: "Buche eine 1-zu-1- oder Kleingruppen-Session in Frankfurt. Analyse, Einschätzung und eine geplante Strategie zur Verbesserung deiner Schlüsselaspekte. Persönlicher Ansatz, Elite-Training und Betreuung.",
        book_your_session: "Session buchen",
        reviews_title: "Unsere Spieler, ihre Erfolge & Bewertungen",
        reviews_sub: "Lies, was unsere Spieler und deren Eltern über unsere Arbeit und Trainingsprogramme denken.",
        rev_trainings: "Training", rev_programs: "Programme",
        our_players_from: "Unsere Spieler aus",
        contact_title: "Kontakt", explore: "Entdecken",
        contact_body: "Wir trainieren die nächste Generation von Elite-Fußballern. Weltklasse-Übungen, strukturierte Programme und 1-zu-1- & Gruppen-Sessions in Frankfurt am Main.",
        social_connect: "Social · Verbinden",
        order_title: "Kauf abschließen",
        order_first: "Vorname", order_last: "Nachname", order_email: "E-Mail",
        order_pay: "Mit Karte bezahlen", order_cancel: "Abbrechen",
        impressum: "Impressum", datenschutz: "Datenschutz", cookie: "Cookies",
    },
};

export function LangProvider({ children }) {
    const [lang, setLangState] = useState(() =>
        (typeof window !== "undefined" && localStorage.getItem("epa_lang")) || "en"
    );
    useEffect(() => { localStorage.setItem("epa_lang", lang); }, [lang]);
    const setLang = (l) => setLangState(l === "de" ? "de" : "en");
    const t = (key) => (T[lang] && T[lang][key]) || T.en[key] || key;
    return (
        <LangContext.Provider value={{ lang, setLang, t }}>
            {children}
        </LangContext.Provider>
    );
}

export function useLang() { return useContext(LangContext); }
